'use strict';

var one = require('./one');

module.exports = all;

/* Stringify all children of `parent`. */
function all(ctx, parent) {
  var children = parent && parent.children;
  var length = children && children.length;
  var index = -1;
  var results = [];

  while (++index < length) {
    results[index] = one(ctx, children[index], index, parent);
  }

  return results.join('');
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/lib/all.js
// module id = 76
// module chunks = 96961042003272 139266963665775